import React, { useState } from "react";
import { BsArrowLeft } from "react-icons/bs";
import useAuthAxios from "../../../utils/baseAxios";
import { API } from "../../../constants/api";
import { useMutation, useQuery } from "@tanstack/react-query";
import ClipLoader from "react-spinners/ClipLoader";
import { toast } from "react-hot-toast";
import { errorMessage } from "../../../utils/errorMessage";
import { useUser } from "../../../context/user-context";
import OtpPin from "../../../components/OtpPin";

const GoogleAuth = ({ setOpenGAuth }: any) => {
  const { refetch } = useUser();
  const axiosInstance = useAuthAxios();
  const [otp, setOtp] = useState<string>("");

  const getQRCode = async () => {
    const response = await axiosInstance.post(API.requestQrcode, {});
    return response.data.data;
  };
  const { data, isLoading } = useQuery({
    queryKey: ["get-google-qrcode"],
    queryFn: getQRCode,
    retry: 1,
  });
  const imageData = data?.qrcode?.image;
  const toggleGoogle2fa = async ({ totp }: any) => {
    const response = await axiosInstance.post(API.activateGoogleAuth, {
      totp,
    });
    return response.data;
  };
  const completeActivateGAuth = useMutation({
    mutationFn: toggleGoogle2fa,
    onSuccess: (r) => {
      toast.success(r.message);
      setTimeout(() => {
        setOpenGAuth(false);
      }, 1500);
      refetch();
    },
    onError: (e) => {
      console.log(e);
      const err = e as any;
      toast.error(errorMessage(err?.message || err?.data?.message));
    },
  });
  return (
    <div className="fixed inset-0  flex font-manrope justify-start items-start pt-16 overflow-auto pb-16 bg-[#E7EBEE] dark:bg-primary_dark dark:bg-opacity-95  backdrop-blur-sm">
      <div
        className={` w-11/12 mds:w-8/12 md:7/12 border dark:border-[#303030] bg-white  rounded-xl mx-auto p-6 dark:bg-[#192025]   lgss:w-2/5 xxl:w-1/3 `}
      >
        <div className="w-full flex justify-start gap-6 items-center">
          <button
            onClick={() => {
              setOpenGAuth(false);
            }}
          >
            <BsArrowLeft className="text-black dark:text-white text-[20px]" />
          </button>
          <h4 className="text-gray-900 dark:text-gray-100 font-sora font-semibold text-[20px]">
            Google 2FA
          </h4>
        </div>
        <div className="mt-6 w-full px-6 flex flex-col justify-center items-center">
          {isLoading ? (
            <div className="flex justify-center items-center mt-6">
              <ClipLoader color="#0B75C2" size={80} />
            </div>
          ) : (
            <div className="w-3/5 h-[200px] mx-auto  rounded-xl ">
              <img src={imageData} className="w-full h-full bg-cover" alt="" />
            </div>
          )}
          <h4 className="text-[14px] mt-6 text-gray-500 dark:text-gray-400  text-center">
            Kindly scan the QRcode above with your google authenticator app
          </h4>
          <h4 className="text-[14px] mt-2  text-gray-500 dark:text-gray-400 mb-4 text-center ">
            And add the OTP below to activate
          </h4>
          <OtpPin otp={otp} setOtp={setOtp} input={6} />
        </div>
        <button
          disabled={otp.length !== 6}
          onClick={() => {
            completeActivateGAuth.mutate({
              totp: otp,
            });
          }}
          className={
            otp.length !== 6
              ? "w-full mt-6 bg-gray-400 rounded-xl h-[48px] text-gray-200 text-[15px]"
              : "w-full mt-6 bg-secondary_button rounded-xl h-[48px] text-white text-[15px]"
          }
        >
          {completeActivateGAuth.isPending ? (
            <ClipLoader color="#FFFFFF" size={30} />
          ) : (
            "Activate"
          )}
        </button>
      </div>
    </div>
  );
};

export default GoogleAuth;
